export const locationPages = {
  oesterreich: {
    path: "/webdesign-agentur-oesterreich",
    title: "Webdesign Agentur Österreich",
    metaTitle: "Webdesign Agentur Österreich | Professionelle Websites & Branding",
    metaDescription:
      "Webdesign Agentur für ganz Österreich: Professionelle Websites, Corporate Design und Branding. Von Wolfsberg aus für Unternehmen in Wien, Graz, Kärnten und ganz Österreich.",
    h1: "Webdesign Agentur Österreich – Websites & Branding für Unternehmen",
    intro:
      "Marmoris ist Ihre Agentur für Digital Marketing, Social Media und Webdesign mit Sitz in Wolfsberg, Kärnten. Wir entwickeln professionelle Websites und starke Markenauftritte als Teil Ihrer digitalen Vermarktung für Unternehmen in ganz Österreich – von Wien über Graz bis Klagenfurt und Villach.",
    sections: [
      {
        title: "Webdesign & Branding in ganz Österreich",
        content:
          "Ob Kleinunternehmen oder mittelständisches Unternehmen: Wir erstellen maßgeschneiderte Websites, die Ihre Zielgruppe ansprechen und Ihre Marke konsistent darstellen. Unser Fokus liegt auf klarem Design, guter Nutzerführung und technischer Qualität.",
      },
      {
        title: "Warum eine Webdesign Agentur aus Kärnten?",
        content:
          "Als Agentur in Südkärnten kennen wir die regionalen Märkte und arbeiten gleichzeitig für Kunden in ganz Österreich. Persönliche Betreuung, kurze Wege und ein klares Verständnis für österreichische Unternehmen zeichnen uns aus.",
      },
    ],
    faqs: [
      {
        q: "Betreut Marmoris Kunden in ganz Österreich?",
        a: "Ja. Unser Sitz ist in Wolfsberg, Kärnten – die Zusammenarbeit erfolgt per Videocall, E-Mail und Projektmanagement. Viele unserer Kunden sitzen in Wien, Graz, Klagenfurt, Villach oder anderen Regionen Österreichs.",
      },
      {
        q: "Was kostet eine professionelle Website in Österreich?",
        a: "Die Kosten hängen von Umfang, Design und Funktionalität ab. Wir bieten transparente Angebote und eine kostenlose Erstberatung, um Ihren Bedarf einzuschätzen.",
      },
    ],
    areaName: "Österreich",
  },
  kaernten: {
    path: "/webdesign-agentur-kaernten",
    title: "Webdesign Agentur Kärnten",
    metaTitle: "Webdesign Agentur Kärnten | Websites & Branding aus Wolfsberg",
    metaDescription:
      "Webdesign und Branding in Kärnten: Marmoris aus Wolfsberg entwickelt professionelle Websites für Unternehmen in Klagenfurt, Villach, Wolfsberg und ganz Kärnten.",
    h1: "Webdesign Agentur Kärnten – Ihre Partner für Website & Branding",
    intro:
      "Marmoris hat seinen Sitz in Wolfsberg, Kärnten. Wir unterstützen Unternehmen in ganz Kärnten mit Digital Marketing, Social Media und professionellem Webdesign – von Klagenfurt über Villach bis Wolfsberg. Websites und Branding sind dabei zentrale Bausteine Ihrer digitalen Präsenz.",
    sections: [
      {
        title: "Webdesign in Kärnten aus einer Hand",
        content:
          "Von der ersten Idee bis zum Launch: Wir planen und realisieren Websites, die zu Ihrem Unternehmen passen. Klagenfurt, Villach, Wolfsberg, St. Veit, Spittal – wir arbeiten mit Kunden in der gesamten Region Kärnten.",
      },
      {
        title: "Lokal verankert, professionell aufgestellt",
        content:
          "Als Kärntner Agentur kennen wir die lokale Wirtschaft und die Anforderungen von KMU in der Region. Gleichzeitig setzen wir Standards in Design und Technik, die mit Agenturen in größeren Städten mithalten.",
      },
    ],
    faqs: [
      {
        q: "Wo genau sitzt Marmoris in Kärnten?",
        a: "Unser Sitz ist in Wolfsberg, 9400 Wolfsberg, Kärnten. Die Zusammenarbeit kann vor Ort oder remote erfolgen.",
      },
      {
        q: "Betreut ihr auch Unternehmen in Klagenfurt und Villach?",
        a: "Ja. Viele unserer Kunden kommen aus dem Raum Klagenfurt, Villach und dem Lavanttal. Wir arbeiten ortsunabhängig mit modernen Tools.",
      },
    ],
    areaName: "Kärnten",
  },
  klagenfurt: {
    path: "/webdesign-agentur-klagenfurt",
    title: "Webdesign Agentur Klagenfurt",
    metaTitle: "Webdesign Agentur Klagenfurt | Professionelle Websites für KMU",
    metaDescription:
      "Webdesign Agentur für Klagenfurt und Umgebung: Professionelle Websites, Branding und Corporate Design. Marmoris – Ihre Agentur aus Kärnten für Klagenfurt.",
    h1: "Webdesign Agentur Klagenfurt – Websites für Unternehmen in der Landeshauptstadt",
    intro:
      "Sie suchen eine Agentur für Webdesign oder Digital Marketing in Klagenfurt? Marmoris entwickelt aus Kärnten professionelle Websites und Markenauftritte für Unternehmen in Klagenfurt – als Teil einer klaren digitalen Vermarktungs- und Social-Media-Strategie.",
    sections: [
      {
        title: "Webdesign für Klagenfurt und Umgebung",
        content:
          "Ob Einzelunternehmen, Handwerksbetrieb oder Dienstleister in Klagenfurt: Wir erstellen Websites, die Vertrauen schaffen und Kunden ansprechen. Moderne Technik, klares Design und Suchmaschinen-Optimierung inklusive.",
      },
    ],
    faqs: [
      {
        q: "Arbeitet Marmoris mit Kunden in Klagenfurt zusammen?",
        a: "Ja. Wir betreuen Kunden in Klagenfurt und Umgebung. Die Abstimmung erfolgt per Videocall und E-Mail; bei Bedarf sind Besuche vor Ort möglich.",
      },
    ],
    areaName: "Klagenfurt",
  },
  villach: {
    path: "/webdesign-agentur-villach",
    title: "Webdesign Agentur Villach",
    metaTitle: "Webdesign Agentur Villach | Websites & Branding aus Kärnten",
    metaDescription:
      "Webdesign und Branding für Villach: Professionelle Websites für Unternehmen in Villach und Region. Marmoris – Ihre Agentur aus Kärnten.",
    h1: "Webdesign Agentur Villach – Professionelle Websites für Ihre Region",
    intro:
      "Unternehmen in Villach und Umgebung vertrauen auf Marmoris für Digital Marketing, Social Media und Webdesign. Wir entwickeln Websites, die zu Ihrem Unternehmen passen und sich in Ihre digitale Vermarktung und Online-Präsenz einfügen.",
    sections: [
      {
        title: "Ihre Webdesign-Partner für Villach",
        content:
          "Von Villach aus oder für Villach: Wir realisieren Websites mit Fokus auf Nutzerfreundlichkeit und Suchmaschinen-Optimierung. Ideal für Handwerker, Ärzte, Restaurants und Unternehmen in der Region Villach.",
      },
    ],
    faqs: [
      {
        q: "Kann ich als Unternehmen aus Villach mit Marmoris zusammenarbeiten?",
        a: "Ja. Viele unserer Kunden kommen aus Villach und der Umgebung. Die Zusammenarbeit ist ortsunabhängig möglich.",
      },
    ],
    areaName: "Villach",
  },
  graz: {
    path: "/webdesign-agentur-graz",
    title: "Webdesign Agentur Graz",
    metaTitle: "Webdesign Agentur Graz & Steiermark | Websites aus Kärnten",
    metaDescription:
      "Webdesign für Graz und Steiermark: Marmoris entwickelt professionelle Websites und Branding für Unternehmen in Graz und der Steiermark. Österreichweite Zusammenarbeit.",
    h1: "Webdesign Agentur Graz – Websites & Branding für die Steiermark",
    intro:
      "Sie suchen eine Agentur für Webdesign oder Online-Marketing in Graz? Marmoris arbeitet österreichweit und entwickelt professionelle Websites und digitale Marketing-Strategien für Unternehmen in Graz, Steiermark und ganz Österreich.",
    sections: [
      {
        title: "Webdesign für Graz und Steiermark",
        content:
          "Ob Graz, Leibnitz, Kapfenberg oder andere Orte in der Steiermark: Wir erstellen Websites, die Ihre Zielgruppe ansprechen. Klare Struktur, modernes Design und technische Qualität für bessere Sichtbarkeit.",
      },
    ],
    faqs: [
      {
        q: "Betreut Marmoris auch Kunden in Graz?",
        a: "Ja. Wir arbeiten mit Kunden in Graz und der gesamten Steiermark. Die Kommunikation erfolgt remote; bei Bedarf sind Besuche möglich.",
      },
    ],
    areaName: "Graz",
  },
  wolfsberg: {
    path: "/webdesign-agentur-wolfsberg",
    title: "Webdesign Agentur Wolfsberg",
    metaTitle: "Webdesign Agentur Wolfsberg | Ihre Agentur vor Ort in Kärnten",
    metaDescription:
      "Webdesign Agentur Wolfsberg: Marmoris sitzt in Wolfsberg, Kärnten. Professionelle Websites, Branding und Corporate Design für Unternehmen in Wolfsberg und dem Lavanttal.",
    h1: "Webdesign Agentur Wolfsberg – Ihre Agentur vor Ort",
    intro:
      "Marmoris ist in Wolfsberg, Kärnten, zu Hause. Wir unterstützen Unternehmen in Wolfsberg und dem Lavanttal mit digitaler Vermarktung, Social Media und Webdesign – persönlich und professionell.",
    sections: [
      {
        title: "Webdesign in Wolfsberg und Lavanttal",
        content:
          "Kurze Wege, persönliche Beratung: Als Wolfsberger Agentur kennen wir die Region und die Anforderungen lokaler Unternehmen. Von der Website über das Corporate Design bis zur digitalen Strategie – alles aus einer Hand.",
      },
    ],
    faqs: [
      {
        q: "Wo befindet sich Marmoris in Wolfsberg?",
        a: "Unser Sitz ist in 9400 Wolfsberg, Weinleiten 7. Gerne vereinbaren wir ein persönliches Gespräch vor Ort.",
      },
    ],
    areaName: "Wolfsberg",
  },
};
